const SlideEditorCSS = () => {
  return (
    <style>
      {' '}
      {` 

      #slide-editor-carousel .carousel {
        height: calc(100vh - 56px);
        /* Adjust for navbar height */
        max-width: 570px;
        margin-left: auto;
        margin-right: auto;
      }

      #slide-editor-carousel .carousel-inner {
        height: 100%;
      }

      #slide-editor-carousel .carousel-item {
        height: 100%;
      }

      #slide-editor-carousel .carousel-item img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      .footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: black;
        color: white;
        text-align: center;
      }


  .carousel-image {
    height: 100vh;
    object-fit: cover;
  }

  .logline-caption {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}
.tagline-caption {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}
.synopsis-caption {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}
      @media (min-width: 570px) {
        .carousel {
          max-width: 570px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      @media (min-width: 1128px) {
        #navbarItems {
          max-width: 1128px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      .wrapper-class {
  padding: 1rem;
  border: 1px solid #ccc;
}
.editor-class {
  background-color:lightgray;
  padding: 1rem;
  border: 1px solid #ccc;
}
.toolbar-class {
  border: 1px solid #ccc;
}
      `}
    </style>
  );
};

export default SlideEditorCSS;
